import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";

const SECTIONS = [
  { num: "01", name: "Education", id: "education" },
  { num: "02", name: "Experience", id: "experience" },
  { num: "03", name: "Projects", id: "projects" },
  { num: "04", name: "Skills", id: "skills" },
  { num: "05", name: "Contact", id: "contact" },
];

const Navbar = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const bodyClass = document.body.classList;
    if (isDarkMode) bodyClass.add("dark-mode");
    else bodyClass.remove("dark-mode");
  }, [isDarkMode]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    ["home", ...SECTIONS.map((s) => s.id)].forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const toggleDarkMode = () => setIsDarkMode((v) => !v);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <a href="#home" className="navbar-mark" aria-label="Home">
        <span className="navbar-mark-letters">EN</span>
      </a>

      <div className="navbar-links">
        {SECTIONS.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={`navbar-link ${active === item.id ? "is-active" : ""}`}
          >
            <span className="navbar-link-num">{item.num}</span>
            <span className="navbar-link-name">{item.name}</span>
          </a>
        ))}
      </div>

      <button
        className="navbar-theme-toggle"
        onClick={toggleDarkMode}
        aria-label="Toggle dark mode"
      >
        <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
      </button>
    </nav>
  );
};

export default Navbar;
